module.exports = __webpack_public_path__ + "img/6.ad8a83b.jpg";